import React from 'react';
import Slider from 'react-slick';
import './ViewSlider.css';
import { Link } from 'react-router-dom';
import CustomLink from '../../components/CustomLink/CustomLink';

const ViewSlider = ({ title, link, text, items }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
    ],
  };

  return (
    <div className="view-slider-container">
      <div className="view-slider-header-container">
        <h1 className="view-slider-header">{title}</h1>
        <CustomLink link={link} linktext={text} />
      </div>

      <Slider {...settings}>
        {items.map((item, index) => (
          <Link to={`/${link}/${item._id}`} key={index} className="view-slider-card-link">
            <div className="view-slider-card">
              <img
                src={item.photo[0]?.url || '/placeholder.jpg'} // Use photo[0].url or fallback to a placeholder
                alt={item.title}
                className="view-slider-photo"
              />
              <h3 className="view-slider-title">{item.title}</h3>
              <p className="view-slider-details">{item.details}</p>
            </div>
          </Link>
        ))}
      </Slider>
    </div>
  );
};

export default ViewSlider;
